export default __webpack_public_path__ + "static/media/catalog_step_img02.ddbfb138.svg";